import { GET_CAMPAIGNS, GET_CAMPAIGNS_SUCCESS, GET_CAMPAIGNS_FAILURE, GET_REPORT, GET_REPORT_SUCCESS, GET_REPORT_FAILURE } from '../actions/types';

const initialState = {
  campaigns: [],
  report: {},  // Changed this to an empty object based on your API response format
  loading: false,
  error: null,
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_REPORT_SUCCESS':
      return {
        ...state,
        reports: action.payload,
        loading: false,
        error: null,
      };
    case 'FETCH_REPORT_FAILURE':
      return {
        ...state,
        reports: [],
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reportReducer;
